import Skeleton from 'react-loading-skeleton';

import { ConversationDetailsSkeleton } from './ConversationDetailsPage.styled';

export const SkeletonConversationDetailsPage = () => {
    return (
        <ConversationDetailsSkeleton.Container>
            <ConversationDetailsSkeleton.Label>
                <Skeleton height={18} width={'50%'} />
            </ConversationDetailsSkeleton.Label>
            <ConversationDetailsSkeleton.Message>
                <Skeleton height={52} width={'100%'} />
            </ConversationDetailsSkeleton.Message>
            <ConversationDetailsSkeleton.Label>
                <Skeleton height={18} width={'50%'} />
            </ConversationDetailsSkeleton.Label>
            <ConversationDetailsSkeleton.Message>
                <Skeleton height={52} width={'100%'} />
            </ConversationDetailsSkeleton.Message>
            <ConversationDetailsSkeleton.Text>
                <Skeleton height={24} width={'100%'} />
                <Skeleton height={24} width={'50%'} />
            </ConversationDetailsSkeleton.Text>
            <ConversationDetailsSkeleton.Label>
                <Skeleton height={18} width={'50%'} />
            </ConversationDetailsSkeleton.Label>
            <ConversationDetailsSkeleton.Message>
                <Skeleton height={52} width={'100%'} />
            </ConversationDetailsSkeleton.Message>
        </ConversationDetailsSkeleton.Container>
    );
};
